import {
  Button,
  Checkbox,
  DatePicker,
  Form,
  Input,
  Modal,
  message,
} from "antd";
import "./styles/paymentRequestPopup.css";
import FormItem from "antd/es/form/FormItem";
import { CopyOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import config from "../../../config";
import { downloadPartnerDocument } from "../../../Utils/adminPartnerUtils";
import { getPartnerDetails } from "../../../Utils/partnerUtils";
const base_url = config.base_url;

function PaymentRequestPopup({
  open,
  onOk,
  onCancel,
  data,
  setData,
  setFilteredData,
  currencyData,
}) {
  const isPending = data?.status === "pending";

  const [messageApi, contextHolder] = message.useMessage();
  const [invoiceConfirmed, setInvoiceConfirmed] = useState(false);
  const [openMissingInfoModal, setOpenMissingInfoModal] = useState(false);
  const closeMissingInfoModal = () => {
    setOpenMissingInfoModal(false);
  };
  const downloadInvoice = (partner_id, invoice_id) => {
    getPartnerDetails(partner_id)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const { files } = data;
        const invoice_data = files.filter((e) => e?.id === invoice_id)[0];
        downloadPartnerDocument(partner_id, invoice_id, invoice_data?.fileName);
      })
      .catch((e) => console.log(e));
  };
  const updateTableData = () => {
    fetch(base_url + "admin/partners/validations/data", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: ``,
    })
      .then((res) => res.json())
      .then((res) => {
        const content = res.data
          .sort((a, b) => {
            return b.date - a.date;
          })
          .map((data, i) => {
            return {
              ...data,
              date: dayjs(res.data[0].date).format("YYYY-MM-DD"),
              completed_date: dayjs(res.data[0].completed_date).format(
                "YYYY-MM-DD"
              ),
              index: res.data.length - i,
            };
          });
        setData(content);
        setFilteredData(content);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const completePayment = async () => {
    const transactionDate = form.getFieldValue(["transaction_date"]).valueOf();
    const transactionID = form.getFieldValue(["transactionId"]);

    await fetch(base_url + "admin/partners/validations/payment/complete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `request_id=${data.id}&transaction_id=${transactionID}&transaction_date=${transactionDate}`,
    })
      .then((res) => {
        success("Payment marked completed");
        updateTableData();
        onOk();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const missingInfo = async () => {
    await fetch(base_url + "admin/partners/validations/payment/reject", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `request_id=${data.id}`,
    })
      .then((res) => {
        updateTableData();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const success = (text) => {
    messageApi.open({
      type: "success",
      content: text,
    });
  };
  const [form] = Form.useForm();
  useEffect(() => {
    if (data.payment_method === "bank") {
      form.setFieldsValue({
        amount: data.quantity * currencyData[data?.currency],
        currency: data.currency,
        account_owner_name: data.payment_details.bank_owner_name,
        country: data.payment_details.bank_country,
        bic: data.payment_details.bank_bic,
        iban: data.payment_details.bank_iban,
        partnerName: data.partner_name,
        partnerType: data.partner_type,
        contact_full_name: data.contact_name,
        emailAddress: data.partner_email,
        phoneNumber: data.phone_number,
        transaction_date: dayjs(new Date().now),
        missedInfo: data.partner_email,
      });
    } else if (data.payment_method === "paypal") {
      form.setFieldsValue({
        amount: data.quantity * currencyData[data?.currency],
        currency: data.currency,
        paypal_account: data.payment_details.paypal_account,
        partnerName: data.partner_name,
        partnerType: data.partner_type,
        contact_full_name: data.contact_name,
        emailAddress: data.partner_email,
        phoneNumber: data.phone_number,
        transaction_date: dayjs(new Date().now),
        missedInfo: data.partner_email,
      });
    }
  }, [data]);

  return (
    <>
      <Modal
        className="paymentRequestModal"
        open={open}
        onOk={onOk}
        onCancel={(e) => {
          onCancel();

          setInvoiceConfirmed(false);
        }}
        footer={[
          <div
            key={1}
            style={{
              display: "flex",
              padding: "0 25px",
              marginTop: "40px",
              justifyContent: "space-between",
            }}
          >
            <Button
              // disabled={isPending ? (invoiceConfirmed ? false : true) : true}
              disabled={isPending ? false : true}
              className="missingInfo"
              onClick={(e) => {
                setOpenMissingInfoModal(true);
                missingInfo();
              }}
            >
              Missing or Incorrect Information
            </Button>

            <Button
              style={{
                height: "40px",
                marginLeft: "auto",
              }}
              onClick={(e) => {
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={(e) => {
                // completePayment();
                form.submit();
              }}
              style={{marginLeft:'20px'}}
              className="markCompleteButton"
              disabled={isPending ? (invoiceConfirmed ? false : true) : true}
            >
              Mark As Complete
            </Button>
          </div>,
        ]}
      >
        {contextHolder}

        <Form form={form} className="container" onFinish={completePayment}>
          <h2>Payment Request</h2>
          <div className="containerFirstSection">
            <div className="containerLeftColumn">
              <p className="containerLeftColumnSubtitle">Amount to be Paid</p>
              <div className="containerLeftColumnFirstRow">
                <FormItem
                  style={{
                    width: "100%",
                  }}
                  label="Amount"
                  name="amount"
                  labelCol={{ span: 24 }}
                >
                  <Input disabled className="amountInput"  />
                </FormItem>
                <FormItem
                  style={{
                    width: "100%",
                  }}
                  label="Currency"
                  name="currency"
                  labelCol={{ span: 24 }}
                >
                  <Input
                    style={{ textTransform: "uppercase" }}
                    disabled
                    className="amountInput"
                  />
                </FormItem>
                <FormItem
                  style={{
                    width: "100%",
                  }}
                  label="Invoice"
                  name="amount"
                  labelCol={{ span: 24 }}
                >
                  <Button
                    onClick={() =>
                      downloadInvoice(
                        data?.partner_id,
                        data?.invoice_id,
                        data?.invocie_id
                      )
                    }
                    className="downloadButton"
                  >
                    Download Invoice
                  </Button>
                </FormItem>
              </div>
              {data.payment_method === "paypal" ? (
                <p className="containerLeftColumnSubtitle">Method: Paypal</p>
              ) : (
                <p className="containerLeftColumnSubtitle">
                  Method: Bank Transfer
                </p>
              )}
              {data.payment_method === "paypal" && (
                <div className="formItemWrapper">
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Paypal Account"
                    name="paypal_account"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["paypal_account"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
              )}
              {data.payment_method === "bank" && (
                <>
                  {" "}
                  <div className="formItemWrapper">
                    <FormItem
                      style={{
                        width: "100%",
                      }}
                      label="Account Owner Name"
                      name="account_owner_name"
                      labelCol={{ span: 24 }}
                    >
                      <Input disabled className="formInput" />
                    </FormItem>
                    <CopyOutlined
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          form.getFieldValue(["account_owner_name"])
                        );
                        success("Text Copied");
                      }}
                      className="InputCopyicon"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "25px",
                    }}
                  >
                    <div className="formItemWrapper">
                      <FormItem
                        style={{
                          width: "100%",
                        }}
                        label="Country"
                        name="country"
                        labelCol={{ span: 24 }}
                      >
                        <Input disabled className="formInput" />
                      </FormItem>
                      <CopyOutlined
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            form.getFieldValue(["country"])
                          );
                          success("Text Copied");
                        }}
                        className="InputCopyicon"
                      />
                    </div>
                    <div className="formItemWrapper">
                      <FormItem
                        style={{
                          width: "100%",
                        }}
                        label="BIC"
                        name="bic"
                        labelCol={{ span: 24 }}
                      >
                        <Input disabled className="formInput" />
                      </FormItem>
                      <CopyOutlined
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            form.getFieldValue(["bic"])
                          );
                          success("Text Copied");
                        }}
                        className="InputCopyicon"
                      />
                    </div>
                  </div>
                  <div
                    className="formItemWrapper"
                    style={{
                      width: "100%",
                    }}
                  >
                    <FormItem
                      style={{
                        width: "100%",
                      }}
                      label="IBAN"
                      name="iban"
                      labelCol={{ span: 24 }}
                    >
                      <Input disabled className="formInput" />
                    </FormItem>
                    <CopyOutlined
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          form.getFieldValue(["iban"])
                        );
                        success("Text Copied");
                      }}
                      className="InputCopyicon"
                    />
                  </div>
                </>
              )}
            </div>
            <div className="containerRightColumn">
              <p className="containerRightColumnSubtitle">
                Partner's Contact Details
              </p>
              <div className="containerRightColumnWrapper">
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Partner Name / Company / Brand Name"
                    name="partnerName"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["partnerName"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Partner Type"
                    name="partnerType"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["partnerType"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Contact full Name"
                    name="contact_full_name"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["contact_full_name"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>{" "}
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Partner Email Address"
                    name="emailAddress"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["emailAddress"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>{" "}
                <div
                  className="formItemWrapper"
                  style={{
                    width: "100%",
                  }}
                >
                  <FormItem
                    style={{
                      width: "100%",
                    }}
                    label="Contact phone Number"
                    name="phoneNumber"
                    labelCol={{ span: 24 }}
                  >
                    <Input disabled className="formInput" />
                  </FormItem>
                  <CopyOutlined
                    onClick={(e) => {
                      navigator.clipboard.writeText(
                        form.getFieldValue(["phoneNumber"])
                      );
                      success("Text Copied");
                    }}
                    className="InputCopyicon"
                  />
                </div>
              </div>
            </div>
          </div>

          <p className="containerLeftColumnSubtitle">Admin Approval</p>
          <div className="containerSecondSection">
            <FormItem name="invoice_confirmation">
              <Checkbox
                onChange={(e) => {
                  setInvoiceConfirmed(e.target.checked);
                  if (e.target.checked === false) {
                    form.setFieldsValue({
                      transaction_date: dayjs(new Date().now),
                    });
                  }
                }}
              >
                Confirm Invoice Correct and Valid
              </Checkbox>
            </FormItem>
            <div
              className={
                invoiceConfirmed
                  ? "confirmationDataWrapper"
                  : "confirmationDataWrapper disabled"
              }
            >
              <div
                style={{
                  width: "70%",
                  display: "flex",
                  gap: "25px",
                }}
              >
                <FormItem
                  label="Transaction Date"
                  name="transaction_date"
                  labelCol={{ span: 24 }}
                  required={invoiceConfirmed ? true : false}
                  rules={
                    invoiceConfirmed
                      ? [{ required: true, message: "Please enter date" }]
                      : []
                  }
                >
                  <DatePicker
                    style={{
                      width: "100%",
                      height: "46px",
                    }}
                    allowClear={false}
                    format="YYYY-MM-DD"
                    placeholder="YYYY-MM-DD"
                    disabled={
                      isPending ? (invoiceConfirmed ? false : true) : true
                    }
                    className="transactionInput"
                  />
                </FormItem>
                <FormItem
                  label="Transaction ID / Refrence"
                  name="transactionId"
                  labelCol={{ span: 24 }}
                  required={invoiceConfirmed ? true : false}
                  rules={
                    invoiceConfirmed
                      ? [
                          {
                            required: true,
                            message: "Please enter transaction ID",
                          },
                        ]
                      : false
                  }
                >
                  <Input
                    disabled={
                      isPending ? (invoiceConfirmed ? false : true) : true
                    }
                    className="transactionInput"
                    placeholder="Insert transaction ID"
                    rules={
                      invoiceConfirmed
                        ? [
                            {
                              required: true,
                              message: "Please enter Transaction ID / Refrence",
                            },
                          ]
                        : []
                    }
                  />
                </FormItem>
              </div>
            </div>
          </div>
          <Modal
            closeIcon={false}
            open={openMissingInfoModal}
            onCancel={closeMissingInfoModal}
            className="missingInfoModal"
            footer={[
              <div
                style={{
                  display: "flex",
                }}
              >
                <Button
                  onClick={(e) => {
                    closeMissingInfoModal();
                    setTimeout(() => {
                      onCancel();
                    }, 100);
                  }}
                  style={{
                    margin: "auto",
                    width: "165px",
                  }}
                  className="missingInfo"
                >
                  Close Request Window
                </Button>
              </div>,
            ]}
          >
            <div className="missingInfoModalContent">
              <h2>Status Changed!</h2>
              <p>Contact the partner by email to report him for the issue</p>
              <div
                className="formItemWrapper"
                style={{
                  height: "max-content",
                }}
              >
                <FormItem
                  style={{
                    width: "100%",
                  }}
                  name="missedInfo"
                >
                  <Input disabled className="formInput" />
                </FormItem>
                <CopyOutlined
                  style={{
                    bottom: "38px",
                  }}
                  onClick={(e) => {
                    navigator.clipboard.writeText(
                      form.getFieldValue(["missedInfo"])
                    );
                    success("Text Copied");
                  }}
                  className="InputCopyicon"
                />
              </div>
            </div>
          </Modal>
        </Form>
      </Modal>
    </>
  );
}

export default PaymentRequestPopup;
